import React, { Fragment, useCallback, useEffect, useState } from "react";
function OptionRS({
  onInputChange,
  catid,
  namemain,
  mainid,
  ref,
  edit,
}) {
  const [data, setData] = useState([]);

  const getdata = useCallback(async () => {
    const sendData = {
      CatgId: Number(catid),
    };
    await fetch(
      process.env.REACT_APP_API_LINK + "api/Main/GetDetailsValueState",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sendData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data)
        setData(data);
      });
  }, [catid]);

  useEffect(() => {
    getdata();
  }, [getdata, catid]);
  return (
    <select
      className="form-control form-select"
      id={mainid}
      ref={ref}
      name={namemain}
      onChange={(e) => {
        onInputChange(e);
      }}
      disabled={edit}
    >
      <option value={"-1"}>{"SELECT A STATE"} </option>

      {data !== []
        ? data.map((optiondata, index) => (
            <Fragment key={index }>
            <option value={optiondata.catgTypeId}>
              {" "}
              {optiondata.catgDesc}
                </option>
            </Fragment>
          ))
        : null}
    </select>
  );
}

export default OptionRS;
